import React, { FC, memo, RefObject, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChatWithShortInfo, MetaResponseChats } from "@sms/shared/chat/chat.interface";
import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";
import { Dispatch } from "redux";

import ChatItemComponent from "./chat-item/chat-item.component";
import styles from "./chat-list.module.scss";
import { ChatsListState } from "./chat-list.types";
import SearchWrapperComponent from "./search/search.component";
import SearchInputComponent from "./search-input/search-input.component";
import ChatFoldersComponent from "./chat-folders/chat-folders.component";

import { ApplicationStore } from "~/app/application.store";
import chatActions from "~/app/chat/chat.actions";

const ChatListComponent: FC = memo(() => {
  const dispatch: Dispatch<any> = useDispatch();
  const [chatsData, setChats]: [ChatsListState, React.Dispatch<React.SetStateAction<ChatsListState>>] =
    useState<ChatsListState>({ chats: [] });

  const refHasNextPage: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const refList: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const chats: ChatWithShortInfo[] = useSelector((state: ApplicationStore) => state.chats.chats);
  const selectChatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);
  const chatsArchivedList: ChatWithShortInfo[] = useSelector(
    (state: ApplicationStore) => state.archive.chatsArchivedList
  );
  const isArchived: boolean = useSelector((state: ApplicationStore) => state.archive.isArchived);
  const isLoadedArchiveChats: boolean = useSelector((state: ApplicationStore) => state.archive.isLoaded);
  const metaChats: MetaResponseChats | null = useSelector((state: ApplicationStore) => state.chats.meta);
  const currentFolder: ChatFolderData | null = useSelector(
    (state: ApplicationStore) => state.chatFolders.currentFolder
  );
  const isOpenSearchWrapper: boolean = useSelector((state: ApplicationStore) => state.search.isOpenSearchWrapper);

  // const [isLoaded, setIsLoaded]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
  // useEffect(() => {
  //   if (chatsData.chats.length > 0) {
  //     setIsLoaded(true);
  //   } else {
  //     setIsLoaded(false);
  //   }
  // }, [chatsData.chats]);

  // useEffect(() => {
  //   if (refHasNextPage.current) {
  //     const observer: IntersectionObserver = new IntersectionObserver(
  //       entries => {
  //         entries.forEach(entry => {
  //           if (entry.isIntersecting && isLoaded) {
  //             // props.getChatsNextPage();
  //           }
  //         });
  //       }
  //       // { root: refList.current ?? null, rootMargin: "-100px 0px 0px 0px" }
  //     );

  //     observer.observe(refHasNextPage.current);
  //     return (): void => {
  //       if (refHasNextPage.current) {
  //         observer.unobserve(refHasNextPage.current);
  //       }
  //     };
  //   }
  // }, [isLoaded]);

  const filterChatsByFolders: () => void = useCallback(() => {
    setChats({
      chats: chats
        .filter(chat => !chat.isArchived)
        .filter(chat => {
          if (chat.folders && chat.folders.length > 0) {
            return chat.folders?.some(folder => {
              if (currentFolder?.id) {
                return folder.id === currentFolder?.id;
              } else {
                return true;
              }
            });
          } else {
            if (currentFolder) {
              return false;
            } else {
              return true;
            }
          }
        })
    });
  }, [currentFolder, chats]);

  useEffect(() => {
    if (isArchived) {
      setChats({ chats: chatsArchivedList });
    } else {
      filterChatsByFolders();
    }
  }, [currentFolder, chats, isArchived, chatsArchivedList]);

  const handleChangeChat: (data: string | null) => void = useCallback(
    (data: string | null): void => {
      dispatch(chatActions.switchSelectChat(data));
    },
    [dispatch]
  );

  return (
    <div className={styles.leftColumnMain}>
      <SearchInputComponent />

      {!isOpenSearchWrapper ? (
        chatsData.chats && (
          <>
            <ChatFoldersComponent />
            <div className={styles.chatList} ref={refList}>
              {isLoadedArchiveChats && <>Loading...</>}
              {chatsData.chats.map(chat => (
                <ChatItemComponent
                  key={chat.id}
                  chat={chat}
                  user={chat.users ? (chat.users[0] ? chat.users[0].user : null) : null}
                  opponentPhone={chat.opponentPhone ? chat.opponentPhone : null}
                  handleChangeChat={handleChangeChat}
                  selectChatId={selectChatId}
                />
              ))}
              {metaChats?.hasNextPage && <div ref={refHasNextPage}></div>}
            </div>
          </>
        )
      ) : (
        <SearchWrapperComponent />
      )}
    </div>
  );
});

ChatListComponent.displayName = "ChatListComponent";

export default ChatListComponent;
